import { List } from 'immutable';
export const INITIALIZE_CANCEL_BOOKING = 'initialize-cancel-booking';
const initializeCancelBooking = ({ selectedParkingPassIds }) => ({
  type: INITIALIZE_CANCEL_BOOKING,
  payload: { selectedParkingPassIds: List(selectedParkingPassIds) },
});
export default initializeCancelBooking;
